import {Cart} from '@app/core/models';
import {createFeatureSelector} from '@ngrx/store';

// selectors

export const getAppCartState = createFeatureSelector<{ cart: Cart }>('cart');
